import { createFileRoute } from '@tanstack/react-router';
import { TERMS_OF_USE } from '@/features/creators/legal/content/terms-of-use';
import { LegalPage } from '@/features/creators/legal/legal-page';
import { seo } from '@/utils/seo';

// /ixi-finance/creators/terms — ixigo Creators Terms of Use. A standalone page
// (the trailing _ keeps it out of the landing route's layout).
export const Route = createFileRoute('/ixi-finance/creators_/terms')({
	head: () => ({
		meta: [
			...seo({
				title: 'ixigo Creators — Terms of Use',
				description: 'ixigo Creators terms of use.',
			}),
			{ name: 'robots', content: 'index, follow' },
		],
	}),
	component: () => <LegalPage document={TERMS_OF_USE} />,
	ssr: true,
});
